import { getItem, getSessionItem } from 'utils/local-storage';
import { DISCOUNT_CODE, URL_QUERY_STRING } from 'utils/storage-keys';
import { message } from 'antd';
import GlobalStore from 'stores/globalStore';
import { getCurrentSubscription } from 'utils/helpers';

type UTMSource = {
  utm_source?: string;
  utm_content?: string;
  utm_term?: string;
  utm_medium?: string;
  utm_campaign?: string;
  placement?: string;
  lead_source?: string;
};

type UpgradeOption = {
  site_code: string;
  session_token: string;
  unused_money: number;
  is_upgrade: boolean;
  user_id: string;
  country: string;
};

const useSaveLead = () => {
  const { entitlements } = GlobalStore.useContainer();

  const getUTM = () => {
    const href = getSessionItem(URL_QUERY_STRING);
    const url = new URLSearchParams(href ? href : '');
    const utmObject = Object.fromEntries(url);
    const utmSource: UTMSource = {
      utm_source: utmObject['utm_source'] || '',
      utm_content: utmObject['utm_content'] || '',
      utm_term: utmObject['utm_term'] || '',
      utm_medium: utmObject['utm_medium'] || '',
      utm_campaign: utmObject['utm_campaign'] || '',
      placement: utmObject['placement'] || '',
      lead_source: utmObject['lead_source'] || 'subscribes'
    };
    return utmSource;
  };

  const isPhoneValid = (number: string) => {
    return  /^(\+?[0-9]{8,12})$/.test(number);
  };

  const getDateOfBirth = (date: string) => {
    // 2006-10-25
    if (!date || date.length !== 10) {
      return '';
    }
    return date.slice(8, 10) + '/' + date.slice(5, 7) + '/' + date.slice(0, 4);
  };

  const saveLead = (profileObject: any, membershipString = 'lifetime_membership', tracking?: UTMSource, upgradeOption?: UpgradeOption) => {
    let discount_code = 'IDTEL';
    if (!entitlements) {
      return;
    }
    const currentPackages = getCurrentSubscription(entitlements);

    const utm = getUTM();

    const formdata: any = {
      fullname: profileObject?.data?.username,
      phone: profileObject?.data?.phone,
      email: profileObject?.data?.email || 'crm@elsanow.io',
      membership: membershipString,
      lead_source: utm.lead_source,
      DOB: getDateOfBirth(profileObject?.data?.date_of_birth),
      Street: profileObject?.data?.address,
      old_package: currentPackages || 'free',
      discount_code: discount_code,
      utm_source: tracking?.utm_source ? tracking.utm_source : utm.utm_source,
      utm_medium: tracking?.utm_medium ? tracking.utm_medium : utm.utm_medium,
      utm_content: utm.utm_content,
      utm_campaign: utm.utm_campaign,
      utm_term: utm.utm_term,
      search: `?placement=${tracking?.placement ? tracking.placement : ''}`,
      'referrer-url': window.location.origin + window.location.pathname
    };

    if(upgradeOption) {
      Object.assign(formdata, upgradeOption);
      const discountCode = getItem(DISCOUNT_CODE) || 'TWTELTW';
      formdata.discount_code = discountCode;
      formdata.search = "?placement=Upgrade";
      const utmMedium = membershipString.includes('premium') ? 'Premium-subscribes' : 'Subscribes';
      formdata.utm_medium = formdata.utm_medium || utmMedium;
    }

    if (!isPhoneValid(profileObject?.data?.phone)) {
      message.error('請輸入正確的電話號碼。');
    } else if(!profileObject?.data?.username){
      message.error('請輸入你的名字。');
    } else {
      const form = document.createElement('form');
      form.method = 'POST';
      if(upgradeOption?.country === 'HK') {
        form.action = `${window.location.origin.replace('tw', 'hk')}/payment`;
      } else {
        form.action = `${window.location.origin}/payment`;
      }

      for (const key in formdata) {
        if (formdata.hasOwnProperty(key)) {
          const hiddenField = document.createElement('input');
          hiddenField.type = 'hidden';
          hiddenField.name = key;
          hiddenField.value = formdata[key];

          form.appendChild(hiddenField);
        }
      }

      document.body.appendChild(form);
      form.submit();
    }
  }
  return { saveLead };
};

export default useSaveLead;
